import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { DataPackageServiceConfig } from './data-package-service.types';

export function provideDataPackageService(config: DataPackageServiceConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: 'dataPackageServiceConfig', useValue: config }
  ]);
}
